import React, { useState } from 'react'
import { createRef } from 'react';
import { Link as RouterLink } from 'react-router-dom'
import { Stack, Grid, Paper, TextField, Avatar } from "@mui/material";
import { FormControlLabel, Checkbox, Button, Typography, Link } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useAuth } from '../components/AuthContext';
import ErrorPaper from '../components/ErrorPaper';

function Login() {
    const [error, setError] = useState<string | null>(null);
    const { onLogin } = useAuth()!;

    let usernameRef = createRef<HTMLInputElement>();
    let passwordRef = createRef<HTMLInputElement>();
    let rememberRef = createRef<HTMLInputElement>();

    const handleLogin = (evt : React.FormEvent<HTMLFormElement>)  => {
        evt.preventDefault();
        onLogin(usernameRef.current!.value, passwordRef.current!.value, rememberRef.current!.checked)
        .catch((err) => {
            setError(err.message);
        });
    };

    const paperStyle = {padding: 20, height: '32vh', width:300, margin:"50px auto"};

    return (
        <form onSubmit={handleLogin} >
            { (error) ? <ErrorPaper error={error} /> : <></> }
            <Paper elevation={10} sx={{minHeight: 400, minWidth:300}} style={paperStyle} >
                <Stack spacing={2} textAlign='center'>
                    <Grid alignSelf={'center'}>
                        <Avatar> <LockOutlinedIcon /> </Avatar>
                    </Grid>
                    <h2> Sign In </h2>
                    <TextField label='Username' placeholder='Enter username' variant='standard' inputRef={usernameRef} fullWidth required />
                    <TextField label='Password' placeholder='Enter password' variant='standard' inputRef={passwordRef} type='password' fullWidth required />
                    <FormControlLabel
                        control={
                            <Checkbox name='checked' color='primary' inputRef={rememberRef} />
                        }
                        label="Remember me"
                    />
                    <Button type='submit' color='primary' variant='contained' fullWidth >Sign In</Button>
                    <Stack spacing={1} textAlign='left'>
                        <Typography>
                            <Link component={RouterLink} to={"/"} > Forgot your password? </Link>
                        </Typography>
                        <Typography>
                            Don't have an account? <Link component={RouterLink} to={"/signup"} > Sign Up! </Link>
                        </Typography>
                    </Stack>
                </Stack>
            </Paper>
        </form>
    );
}

export default Login;